var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMkr0)",
    d: "M3.642 6.916a.43.43 0 0 1 .427-.002l6.856 3.9a.43.43 0 0 1 .217.372v5.529a.429.429 0 1 1-.857 0v-5.28l-6-3.412v8.692a.429.429 0 1 1-.856 0V7.286a.43.43 0 0 1 .213-.37m16.717 0a.43.43 0 0 0-.428-.002l-6.856 3.9a.43.43 0 0 0-.216.372v5.529a.429.429 0 1 0 .857 0v-5.28l5.998-3.412v8.692a.429.429 0 0 0 .858 0V7.286a.43.43 0 0 0-.213-.37"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMkr0",
    x1: 3.429,
    x2: 20.572,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BC4A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586979"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkr);
export default __webpack_public_path__ + "static/media/mkr.e967d66fc0d5dbf721e4a4c1e9b5ce6a.svg";
export { ForwardRef as ReactComponent };